module.exports = __webpack_public_path__ + "static/media/10.09b81db7.jpg";